import React from "react";
import "./VideoField.css";
import Button from "../../../../Button";

function index() {
  return (
    <div className="videofield">
      <div className="videofield_left">
        <iframe
          width="600"
          height="400"
          src="https://www.youtube.com/embed/MvFor6cumHM"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div className="videofield_right">
        <h1>Tashkent</h1>
        <p>
          Tashkent is the most important city of Uzbekistan because this city is
          the capital, the administrative center of the Republic and a very
          unique place where ancient East and modernity are the best neighbors.
          Tashkent is a prosperous metropolis, which population (more than 3
          million people) growing with every day. This city has changed the most
          around all of the other cities of Uzbekistan because of its special
          status of capital. Tashkent is undoubtedly an oriental city, but at
          the same time, it soaked features of different epochs.
        </p>
        <Button title="view more" />
      </div>
    </div>
  );
}

export default index;
